export const getProvider = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud.provider ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.provider_account_name
  );
};

export const getAwsRoleArn = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud_account?.aws_role_arn ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.aws_role_arn
  );
};

export const getAwsUserArn = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud_account?.aws_user_arn ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.aws_user_arn
  );
};

export const getServiceAccount = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud_account.service_account ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.service_account
  );
};

export const getRegions = (subscription: Subscription) => {
  const region = subscription?.rcp?.cloud?.region;

  return region ? [region] : subscription?.aa_rcp?.crdb_regions?.map((r) => r.region_name);
};

export const getStorageEncryption = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cluster.storage_encryption ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.storage_encryption
  );
};

export const getRcpStatus = (subscription: Subscription) => {
  return subscription?.rcp?.status ?? subscription?.aa_rcp?.status;
};

export const getRcpId = (subscription: Subscription): number => {
  return subscription?.rcp?.id || subscription?.aa_rcp?.id;
};

export const getClientPublicAccess = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud?.networking?.client_public_access ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.networking?.client_public_access
  );
};

export const getManagedTags = (subscription: Subscription) => {
  return (
    subscription?.rcp?.cloud?.managed_tags ?? subscription?.aa_rcp?.crdb_regions?.[0]?.managed_tags
  );
};

export const isByocSubscription = (subscription: Subscription) => {
  const ownership =
    subscription?.rcp?.cloud_account?.ownership ??
    subscription?.aa_rcp?.crdb_regions?.[0]?.cloud_account_ownership;

  return ownership === 'external';
};
